export default __webpack_public_path__ + "static/media/4981.19b85f1d.png";